module.exports = __webpack_public_path__ + "img/reviewicn.7761db84.svg";